import styled from "styled-components";

export const BodyContainer = styled.div`
  display: flex;
  min-height: 100vh;
  min-width: 100vh;
  padding-Top: 56px;
  background-color: #070C27;  
`;

